export default __webpack_public_path__ + "static/img/mode-arrow-mobile.69b7c9b.svg";